var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEos = function SvgEos(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.33337L19.366 21.3547L15.75 39.1254L28 46.6667L40.25 39.1254L36.5602 21.28L28 9.33337ZM17.7425 38.304L20.4729 24.7894L26.6717 43.8294L17.7425 38.304ZM21.3584 21.728L28 12.4694L34.6416 21.728L28 42.0374L21.3584 21.728ZM29.2545 43.8294L35.4533 24.7894L38.1837 38.304L29.2545 43.8294Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.4167C12.8582 55.4167 0.583333 43.1418 0.583333 28H-0.583333C-0.583333 43.7861 12.2139 56.5833 28 56.5833V55.4167ZM55.4167 28C55.4167 43.1418 43.1418 55.4167 28 55.4167V56.5833C43.7861 56.5833 56.5833 43.7861 56.5833 28H55.4167ZM28 0.583333C43.1418 0.583333 55.4167 12.8582 55.4167 28H56.5833C56.5833 12.2139 43.7861 -0.583333 28 -0.583333V0.583333ZM28 -0.583333C12.2139 -0.583333 -0.583333 12.2139 -0.583333 28H0.583333C0.583333 12.8582 12.8582 0.583333 28 0.583333V-0.583333Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EOS.e05d9c25ec5a943054e0a42ed4f01593.svg";